// Customer-/Public-Frontend-Wrapper (DESIGN.md §2.5 Customer-Frontend, Off-White durchgängig):
// SessionHeader + zentrierte Card. Plus ein kleines Form-Kit (Field/TextInput/Select/Pill/Hint),
// damit Guest- und Speaker-Vorstufen ohne eigene CSS-Klassen konsistent aussehen.
import type { ButtonHTMLAttributes, InputHTMLAttributes, ReactNode, SelectHTMLAttributes } from 'react';
import { SessionHeader, type SessionStatus } from './SessionHeader';
import styles from './CustomerPage.module.css';

export function CustomerPage({ studio, title, token, status, children }: {
  studio: string;
  title?: string;
  token?: string;
  status?: SessionStatus;
  children: ReactNode;
}) {
  return (
    <div className={styles.page}>
      <SessionHeader studio={studio} title={title} token={token} status={status} />
      <div className={styles.wrap}>
        <div className={styles.card}>{children}</div>
      </div>
    </div>
  );
}

export function CardTitle({ children }: { children: ReactNode }) {
  return <div className={styles.cardTitle}>{children}</div>;
}

export function Field({ label, children }: { label: string; children: ReactNode }) {
  return (
    <label className={styles.field}>
      <span className={styles.label}>{label}</span>
      {children}
    </label>
  );
}

export function TextInput(props: InputHTMLAttributes<HTMLInputElement>) {
  return <input {...props} className={`${styles.input} ${props.className ?? ''}`} />;
}

export function Select(props: SelectHTMLAttributes<HTMLSelectElement>) {
  return <select {...props} className={`${styles.input} ${props.className ?? ''}`} />;
}

export function Pill({ primary, danger, className, ...rest }: { primary?: boolean; danger?: boolean } & ButtonHTMLAttributes<HTMLButtonElement>) {
  const cls = [styles.pill, primary ? styles.pillPrimary : '', danger ? styles.pillDanger : '', className ?? ''].join(' ');
  return <button {...rest} className={cls} />;
}

export function Hint({ tone = 'muted', children }: { tone?: 'muted' | 'live' | 'error'; children: ReactNode }) {
  return <div className={`${styles.hint} ${tone === 'live' ? styles.hintLive : tone === 'error' ? styles.hintError : ''}`}>{children}</div>;
}

export function Row({ children }: { children: ReactNode }) {
  return <div className={styles.row}>{children}</div>;
}
